<template lang="pug">
  .LoadingBlock(v-bind:class='{loading:loading}')
    .loading_content
</template>

<script>

// import { vm } from "../../service/bus"
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
export default{
  // data: function(){
  //   return{
  //     loading: false
  //   }
  // },
  computed: {
    ...mapState([
      'loading'
    ]),
  },
  // methods: {
  //   loadingOn : function(){
  //     this.loading = true;
  //   },
  //   loadingOff : function(){
  //     this.loading = false;
  //   }
  // }
}
</script>


<style lang="scss" scoped>
</style>
